/**
 * Route Vuex Module.
 */
export default {
    namespaced: true,
    state: {
        previousUrl: null,
    },
    actions: {
        /**
         * clear previous url
         *
         * @param {Object} Object
         * @param {String} url
         *
         * @returns {void}
         */
        removePreviousUrl({ commit }) {
            commit('updatePreviousUrl', null)
        },

        /**
         * set the previous url the user navigated from.
         *
         * @param {Object} Object
         * @param {String} url
         *
         * @returns {void}
         */
        setPreviousUrl({ commit }, url) {
            commit('updatePreviousUrl', url)
        },
    },
    mutations: {
        /**
         * Update state previousUrl.
         *
         * @param {Object} state
         * @param {String} url
         *
         * @returns {void}
         */
        updatePreviousUrl(state, url) {
            state.previousUrl = url
        },
    },
    getters: {
        /**
         * Get previous url
         *
         * @param {Object} state
         *
         * @returns {Object}
         */
        getPreviousUrl(state) {
            return state.previousUrl
        },
    },
}
